export function areDifferentDates(timestamp1, timestamp2) {
  const date1 = new Date(timestamp1).toLocaleDateString();
  const date2 = new Date(timestamp2).toLocaleDateString();
  return date1 !== date2;
}